// app/javascript/controllers/bulk_select_controller.js
import { Controller } from "@hotwired/stimulus"

// Controller for bulk selection and actions on list items.
// Usage:
//   <div data-controller="bulk-select">
//     <input type="checkbox" data-bulk-select-target="selectAll" data-action="change->bulk-select#toggleAll">
//     <input type="checkbox" data-bulk-select-target="checkbox" data-action="change->bulk-select#toggleOne">
//     <div data-bulk-select-target="bulkActions" class="hidden">
//       <span data-bulk-select-target="selectedCount">0</span> selected
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "bulkActions", "selectedCount", "form"]

  connect() {
    this.updateUI()
  }

  // Toggle all checkboxes when "select all" is clicked
  toggleAll() {
    const isChecked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateUI()
  }

  // Called when an individual checkbox is toggled
  toggleOne() {
    this.updateSelectAllState()
    this.updateUI()
  }

  // Update the "select all" checkbox state based on individual checkboxes
  updateSelectAllState() {
    if (!this.hasSelectAllTarget) return

    const total = this.checkboxTargets.length
    const checked = this.selectedCount()

    if (checked === 0) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    } else if (checked === total) {
      this.selectAllTarget.checked = true
      this.selectAllTarget.indeterminate = false
    } else {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = true
    }
  }

  // Update UI elements based on selection state
  updateUI() {
    const count = this.selectedCount()

    // Update selected count display
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = count
    }

    // Show/hide bulk actions bar
    if (this.hasBulkActionsTarget) {
      if (count > 0) {
        this.bulkActionsTarget.classList.remove("hidden")
      } else {
        this.bulkActionsTarget.classList.add("hidden")
      }
    }
  }

  // Get the number of selected checkboxes
  selectedCount() {
    return this.checkboxTargets.filter(checkbox => checkbox.checked).length
  }

  // Get the IDs of selected items
  selectedIds() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  // Confirm before performing bulk action
  confirmAction(event) {
    const count = this.selectedCount()
    if (count === 0) {
      event.preventDefault()
      alert("Please select at least one item.")
      return false
    }

    const action = event.currentTarget.querySelector("select")?.value ||
                   event.currentTarget.dataset.action ||
                   "perform this action on"

    const actionLabels = {
      "mark_spam": "mark as spam",
      "mark_cleared": "mark as cleared",
      "mark_spam_and_delete": "mark as spam and delete",
      "archive": "archive",
      "delete": "delete",
      "mark_new": "mark as new",
      "mark_read": "mark as read",
      "flag": "flag"
    }

    const actionLabel = actionLabels[action] || action

    if (!confirm(`Are you sure you want to ${actionLabel} ${count} enquiry(s)?`)) {
      event.preventDefault()
      return false
    }

    return true
  }
}
